import React from 'react';
import FleetNodeCard from './FleetNodeCard';
import FleetUsageTags from './FleetUsageTags';

export default function FleetQuotaNodeCard({ node, onUse }) {
  return (
    <FleetNodeCard node={node} onUse={onUse}>
      <FleetUsageTags node={node} />
    </FleetNodeCard>
  );
}
